import { createSlice, type Draft, type PayloadAction } from '@reduxjs/toolkit';
import { type AppKey, type CompanyKey } from './session';

export type ActiveContext = {
  activeCompanyKey?: CompanyKey;
  activeAppKey?: AppKey;
};

export type AppState = ActiveContext & {
  loadedNecessaryData: boolean;
};

const initialState: AppState = {
  loadedNecessaryData: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    initializeActiveContext: (
      state: Draft<AppState>,
      action: PayloadAction<ActiveContext>
    ) => {
      state.activeCompanyKey = action.payload.activeCompanyKey;
      state.activeAppKey = action.payload.activeAppKey;
      state.loadedNecessaryData = true;
    },
    clearActiveContext: (state: Draft<AppState>) => {
      state.activeCompanyKey = undefined;
      state.activeAppKey = undefined;
    },
  },
});

export const selectAppState = (state: { readonly app: AppState }) => state.app;

export const selectActiveCompanyKey = (state: { readonly app: AppState }) =>
  selectAppState(state).activeCompanyKey;

export const selectActiveAppKey = (state: { readonly app: AppState }) =>
  selectAppState(state).activeAppKey;
